import React from 'react';

import Header from 'components/structure/Header';
import Footer from 'components/structure/Footer';
import Title from 'components/structure/Title';

function Wrapper(props) {
	let {
		className = '',
		title = false
	} = props;
	let header = true;
	if (typeof (props.displayHeader) !== 'undefined') {
		header = props.displayHeader;
	}
	let footer = true;
	if (typeof (props.displayFooter) !== 'undefined') {
		footer = props.displayFooter;
	}

	return (
		<main className={className}>
			{header && (<Header />)}
			<div className="container">
				{title && (<Title {...title} />)}
				{props.children}
			</div>
			{footer && (<Footer />)}
		</main>
	);
}

export default Wrapper;


